var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLink2 = function SvgLink2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#06C",
    strokeLinecap: "round",
    d: "M6.917 4.41v-.75a2.917 2.917 0 0 0-5.833 0v.75M1.084 7.59v.75a2.916 2.916 0 1 0 5.833 0v-.75M4 4.25v3.5"
  })));
};
export default SvgLink2;